import { CustomerPartPrice, InventryLocation, PartInventory } from "@dana/Handlers/ProductAvailabilityHandler";
import ProductAvailabilityState from "@dana/Store/Data/ProductAvailability/ProductAvailabilityState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ProductAvailabilityState = {
    isLoading: false,
    avilabilityLoadSuccess: false,
    productCustomerPrice: {} as CustomerPartPrice,
    productAvailability: {} as PartInventory,
    locations:[] as InventryLocation[],
    productNumber: "",
    customerNumber: "",
    orderType: "",
    requestedQty: 0,
    plantCode: "",
    errorMessage:""
};

const productAvailabilityStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "ProductAvailability/Start": (draft: Draft<ProductAvailabilityState>, action: { isLoading: boolean, avilabilityLoadSuccess: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading, avilabilityLoadSuccess: action.avilabilityLoadSuccess };
        return draft;
    },
    "ProductAvailability/LoadResponse": (draft: Draft<ProductAvailabilityState>, action: { customerPartPrice: CustomerPartPrice, productAvailability: PartInventory, productNumber: string,locations:InventryLocation[], orderType?:string }) => {
        draft = {
            ...draft,
            productCustomerPrice: action.customerPartPrice,
            productAvailability: action.productAvailability,
            locations: action.locations,
            productNumber: action.productAvailability?.partNumber || "",
            plantCode: action.productAvailability?.plantCode || "",
            orderType: action.orderType || "",
        };
        return draft;
    },
    "ProductAvailability/End": (draft: Draft<ProductAvailabilityState>, action: { isLoading: boolean, avilabilityLoadSuccess: boolean ,errorMessage:string}) => {
        draft = { ...draft, isLoading: action.isLoading, avilabilityLoadSuccess: action.avilabilityLoadSuccess, errorMessage: action.errorMessage};

        return draft;
    }
});

(reducers as any).productAvailabilityState = productAvailabilityStateImmerReducer;

type ProductAvailabilityReducers = {
    productAvailabilityState: typeof productAvailabilityStateImmerReducer;
};

export type ProductAvailabilityActions = Parameters<ProductAvailabilityReducers[keyof ProductAvailabilityReducers]>[1] | AnyAction;

